import { Component } from '@angular/core';
import { version, commitSha, buildDate } from '../../environments/version';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'bcs-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  version: string;
  production: string;
  buildInfo: string;
  showDebugModal = false;
  isDevelopment: boolean;

  constructor() {
    this.version = version;
    this.production = environment.production ? 'Production' : 'Development';
    this.isDevelopment = !environment.production;
    this.buildInfo = `v${version} · ${commitSha} · built ${new Date(buildDate).toLocaleString()} · ${this.production}`;
  }

  onImageClick() {
    if (this.isDevelopment) {
      this.showDebugModal = true;
    }
  }

  onDebugModalClose() {
    this.showDebugModal = false;
  }
 }
